<template>
<div class="d-flex " v-if="hasRole(roles.RW_REAL_ESTA_CRED) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
    <div class="col-md-3">
      <UserSearchCard v-on:dataSearch="GetFilter" v-if="!isUserSelected"></UserSearchCard>
      <UserSummaryCard :corretor="corretor" v-if="isUserSelected" :showEnterprises="administrador" :showCreciData="!administrador" :userDataProp="editUser"></UserSummaryCard>
    </div>
    <div class="col-md-9 table-realtors">
            <RealtorTable ref="tableUsersComponent" :key="keyTableUsers" v-on:deleteUser="deleteUser" v-on:inactivateUser="inactivateUser" v-on:selectUser="selectUser" v-if="!isUserSelected"></RealtorTable>
            <UserEditForm :corretor="corretor" :editUserData="editUser" v-on:updateView="updateView" v-if="isUserSelected && !administrador" :hideCreciData="true"></UserEditForm>

            <div v-if="!isUserSelected" class="container-modal">
                <UserAddModal :titleModal="'Adicionar novo Corretor'" v-on:updateTableUsers="updateTableUsers"></UserAddModal>
            </div>
    </div>
</div>

</template>

<script>
import Users from './realtors.js'
export default Users
</script>

<style scoped>

.container-modal{
  position: fixed;
  bottom: calc(50px - 1vh);
  right: 10px;
}

.table-realtors thead, .table-realtors tbody{
  display: block;
}

.table-realtors tbody{
  overflow-y: auto;
  height: 520px;
}

.table-realtors th,
.table-realtors td {
  width: 300px;
}

.text-third {
  font-size: 16px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/users/realtors.vue